import React, { FunctionComponent } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { TableHead, TableRow, TableCell } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cell: {
      paddingLeft: "0px",
      paddingTop: "0px",
      paddingRight: "0px",
      borderBottom: "1px solid #F1F1F1",
      fontWeight: 600,
      fontSize: "18px",
      [theme.breakpoints.down("sm")]: {
        paddingBottom: "9px",
        paddingTop: "9px",
        fontSize: "16px",
      },
      [theme.breakpoints.only("md")]: {
        paddingBottom: "14px",
        paddingTop: "14px",
      },
      [theme.breakpoints.only("lg")]: {
        paddingBottom: "19px",
        paddingTop: "19px",
      },
      [theme.breakpoints.only("xl")]: {
        paddingBottom: "29px",
        paddingTop: "29px",
      },
    },
    phoneNumber: {
      width: "60%",
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "41px",
      },
      [theme.breakpoints.only("md")]: {
        paddingLeft: "65px",
      },
      [theme.breakpoints.only("lg")]: {
        paddingLeft: "87px",
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: "132px",
      },
    },
    status: {
      width: "40%",
    },
  })
);

export const TableHeader: FunctionComponent = () => {
  const classes = useStyles();

  return (
    <TableHead>
      <TableRow>
        <TableCell className={clsx(classes.cell, classes.phoneNumber)}>
          Phone Number
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.status)}>
          Status
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
